const KEY = 'pending_invite_code';

// Valid codes are uppercase alphanumeric, 4-12 chars (matches backend generator)
const CODE_RE = /^[A-Z0-9]{4,12}$/;

export function normalizeCode(raw) {
  if (!raw) return '';
  const cleaned = raw.trim().toUpperCase();
  return CODE_RE.test(cleaned) ? cleaned : '';
}

// Read ?code= from current URL search params
export function readCodeFromUrl(search) {
  try {
    const params = new URLSearchParams(search || window.location.search);
    return normalizeCode(params.get('code'));
  } catch {
    return '';
  }
}

// Merge URL code with stored code (URL takes precedence). Also persists if found.
export function captureInviteCode(search) {
  const fromUrl = readCodeFromUrl(search);
  if (fromUrl) {
    try { localStorage.setItem(KEY, fromUrl); } catch { /* ignore */ }
    return fromUrl;
  }
  try {
    return normalizeCode(localStorage.getItem(KEY));
  } catch {
    return '';
  }
}

export function getPendingInviteCode() {
  try {
    return normalizeCode(localStorage.getItem(KEY));
  } catch {
    return '';
  }
}

export function clearPendingInviteCode() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
